"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7981],{

/***/ 37981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10990);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




// dynamic import
var TextSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2055), __webpack_require__.e(488), __webpack_require__.e(1935)]).then(__webpack_require__.bind(__webpack_require__, 11935));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11935)
            ];
        }
    }
});
function WorkWithUs() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        value: 0
    }), updateCounter = ref[0], setUpdateCounter = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        value: 0
    }), yearsCounter = ref1[0], setYearsCounter = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        value: 0
    }), teamMemberCounter = ref2[0], setTeamMemberCounter = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        value: 0
    }), hqCounter = ref3[0], setHqCounter = ref3[1];
    // Gsap Animations
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var target = {
            value: 0
        };
        var target2 = {
            value: 0
        };
        var target3 = {
            value: 0
        };
        var target4 = {
            value: 0
        };
        var workWithUsTl = gsap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._marketLeading",
                start: "100px 95%"
            }
        });
        var workWithUsTl1 = gsap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._marketLeading",
                start: "100px 95%"
            }
        });
        var workWithUsTl2 = gsap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._marketLeading",
                start: "100px 95%"
            }
        });
        var workWithUsTl3 = gsap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._marketLeading",
                start: "100px 95%"
            }
        });
        workWithUsTl.to(target, {
            duration: 2,
            value: "+=25",
            roundProps: "value",
            ease: "none",
            onUpdate: function onUpdate() {
                setUpdateCounter({
                    value: target.value
                });
            }
        });
        workWithUsTl1.to(target2, {
            duration: 2,
            value: "+=5",
            roundProps: "value",
            ease: "none",
            onUpdate: function onUpdate() {
                setYearsCounter({
                    value: target2.value
                });
            }
        });
        workWithUsTl2.to(target3, {
            duration: 2,
            value: "+=3",
            roundProps: "value",
            ease: "none",
            onUpdate: function onUpdate() {
                setTeamMemberCounter({
                    value: target3.value
                });
            }
        });
        workWithUsTl3.to(target4, {
            duration: 2,
            value: "+=8",
            roundProps: "value",
            ease: "none",
            onUpdate: function onUpdate() {
                setHqCounter({
                    value: target4.value
                });
            }
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "_workWithUsSectionTrigger mb-[100px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "grid w-full !h-full lg:h-[44.444vw] grid-cols-1 lg:grid-cols-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-6 py-6 bg-redblack lg:p-[1.5rem]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex items-center justify-center w-full h-full backgroundDotsWorkWithUs",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-[70.13333vw] lg:w-[38.08333vw] 2xl:w-[31.9vw] 3xl:w-[28vw] 3xl:!h-[26vw] my-20 lg:my-0 px-5 lg:px-4 bg-redblack lg:!h-[40vw] flex flex-col justify-center gap-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextSlider, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-2 workWithUsCounts",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-center aspect-square first-letter:h-full w-full bg-[#F1F1F1]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                        className: "leading-[.81967em] text-[1.85714rem] sm:text-[3.57143rem] text-[#131313] font-bold pb-1.5 lg:pb-2 inline _marketLeading",
                                        children: [
                                            updateCounter.value,
                                            updateCounter.value === 25 && "+"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "w-[4.85714rem] h-[2px] bg-primary block mx-auto mt-5 mb-1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "leading-[1.23077em] text-[.92857rem] md:text-[1.14286rem] md:leading-[1.1875em] text-[#131313] max-w-[12.85714rem] mx-auto pt-4",
                                        children: "25+ black owned & operated clients"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-center aspect-square w-full h-full bg-primary",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                        className: "leading-[.81967em] text-[1.85714rem] sm:text-[3.57143rem] text-white font-bold pb-1.5 lg:pb-0",
                                        children: [
                                            yearsCounter.value,
                                            yearsCounter.value === 5 && "+"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "w-[4.85714rem] h-[2px] bg-white block mx-auto mt-5 mb-1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "leading-[1.23077em] text-[.92857rem] md:text-[1.14286rem] md:leading-[1.1875em] text-white max-w-[12.85714rem]] mx-auto pt-4",
                                        children: [
                                            "years crushing digital ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            " experiences"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-center aspect-square w-full h-full bg-primary",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                        className: "leading-[.81967em] text-[1.85714rem] sm:text-[3.57143rem] text-white font-bold pb-1.5 lg:pb-0",
                                        children: [
                                            teamMemberCounter.value,
                                            teamMemberCounter.value === 3 && "+"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "w-[4.85714rem] h-[2px] bg-white block mx-auto mt-5 mb-1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "leading-[1.23077em] text-[.92857rem] md:text-[1.14286rem] md:leading-[1.1875em] text-white max-w-[12.85714rem]] mx-auto pt-4",
                                        children: [
                                            "fortune500 clients … and ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            " counting",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-center aspect-square w-full h-full bg-[#F1F1F1]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "leading-[.81967em] text-[1.85714rem] sm:text-[3.57143rem] text-[#131313] font-bold pb-1.5 lg:pb-0",
                                        children: hqCounter.value
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "w-[4.85714rem] h-[2px] bg-primary block mx-auto mt-5 mb-1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "leading-[1.23077em] text-[.92857rem] md:text-[1.14286rem] md:leading-[1.1875em] text-[#131313] max-w-[12.85714rem] mx-auto pt-4",
                                        children: "awards received for digital campaigns"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WorkWithUs);


/***/ })

}]);